<template>
<div>
  <pt-page-title :title="(isEdit?'编辑':'新建')+'积分商品'"></pt-page-title>
  <pt-integral-goods-form-withdata :isEdit="isEdit" :id="id" ref="goodsForm"></pt-integral-goods-form-withdata>
   <div class="button-div">
          <el-button type="primary" @click="submitData" :loading="submitLoading||saveLoading">提交</el-button>
          <el-button type="primary" plain :class="$style['submit-button']" @click="save" :loading="saveLoading||submitLoading">保存</el-button>
          <el-button type="primary" plain :class="$style['submit-button']" @click="cancel">取消</el-button>
      </div>
</div>
</template>
<script>
import ptIntegralGoodsFormWithdata from './withData'
export default {
  components: {
    ptIntegralGoodsFormWithdata
  },
  computed: {
    goodsForm () {
      return this.$refs.goodsForm
    }
  },
  props: {
    isEdit: {
      type: Boolean
    },
    id: {
      type: String
    },
    submitLoading: Boolean,
    saveLoading: Boolean
  },
  methods: {
    formData (form) {
      form.divide.validate().then(_ => {
        form.message.validate().then(_ => {
          form.set.validate().then(_ => {
            let data = form.form
            if (!data.goodsDTO.goodsData.carriagePolicyId && !data.goodsDTO.goodsData.carriagePolicy) {
              this.$alert('您未设置运费规则，该商品运费将默认显示为“免运费”。', '运费规则提示', {
                confirmButtonText: '确定',
                type: 'warning' }).then(_ => {
                this.$refs.goodsForm.submit(form.form)
              })
            } else {
              this.$refs.goodsForm.submit(form.form)
            }
          })
        })
      })
    },
    submitData () {
      let form = this.goodsForm.$refs.goodsForm
      form.form.applyForApproval = true
      this.formData(form)
    },
    save () {
      let form = this.goodsForm.$refs.goodsForm
      form.form.applyForApproval = false
      this.formData(form)
    },
    cancel () {}
  }
}
</script>
<style module lang="less">
.submit-button{
    margin-left: 30px!important
}
</style>
